var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownArrow = function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5E5F61",
    d: "M5.412 4.04c-.2.252-.53.256-.734.006L1.413 0H0v.006l4.689 5.808c.2.25.534.248.733-.006L10 0H8.598z"
  })));
};
export { SvgDownArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01LjQxMjA1IDQuMDM5OTVDNS4yMTI0MiA0LjI5MjE4IDQuODgxNDIgNC4yOTYzNSA0LjY3ODM4IDQuMDQ2MkwxLjQxMjczIC0zLjc1MzYyZS0wN0wwIC00LjM3MTE0ZS0wN0wtMi43MzM2MmUtMTAgMC4wMDYyNTMzNUw0LjY4ODYyIDUuODEzOTRDNC44ODk5NSA2LjA2NDA5IDUuMjIyNjYgNi4wNjIgNS40MjIyOCA1LjgwNzY4TDEwIDBMOC41OTc1MSAtNi4xMzA0OGUtMDhMNS40MTIwNSA0LjAzOTk1WiIgZmlsbD0iIzVFNUY2MSIvPgo8L3N2Zz4K";